<template>
  <div class="upload-file-cell">
    <el-link v-if="!value.length" type="primary" @click="chooseFiles">{{ $t('addasn.exhibition.addaccessory') }}</el-link>
    <el-link v-else type="primary" @click="chooseFiles">{{ value.length }}{{ $t('addasn.exhibition.accessoryCount') }}</el-link>
  </div>
</template>

<script>
import Dialog from '@utils/common/dialog'
import Form from '@utils/form'
import UploadSelect from '@/components/select/upload-select/upload-select.vue'

let dialog = new Dialog()

function getData() {
  return { fileType: 'bidding' }
}

function onSuccess(res, file) {
  const data = res.data[0] || {}
  const { fileName, filePath, id } = data
  file.url = '/srmFile/getFile'
  file.fileId = id
  file.baseURL = process.env.VUE_APP_BASE_API
  file.data = { fileId: id }
  this.$emit('input', [...this.value, { fileId: id, fileName: fileName, url: filePath }])
  dialog.loading = false
}

function parse() {
  return this.value.map(item => ({
    name: item.fileName,
    url: '/srmFile/getFile',
    baseURL: process.env.VUE_APP_BASE_API,
    fileId: item.fileId,
    data: { fileId: item.fileId }
  }))
}

function beforeRemove(file) {
  const value = [...this.value]
  value.splice(value.indexOf(file), 1)
  this.$emit('input', value)
}

const fileNoAttrs = {
  url: '/srmFile/uploadFiles',
  name: 'files',
  baseURL: process.env.VUE_APP_BASE_API,
  onSuccess,
  getData,
  parse,
  beforeRemove,
  beforeUpload() {
    dialog.loading = true
  },
  onError() {
    dialog.loading = false
  }
}

const form = new Form('addasn.exhibition')
  .add('value').label('accessory').component(UploadSelect).attrs(fileNoAttrs).col({ span: 24 })

dialog = new Dialog('addasn.exhibition')
  .title('addaccessory')
  .form(form)

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async chooseFiles() {
      const vm = await dialog.open({ attrs: { row: { value: this.value }}})
      this.row.asnBodyFileList = vm.data.value
    }
  }
}
</script>
